import {html, nothing} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import styles from './style.scss';
import {ASSETS_PATH} from '#lit/common/constants/index.js';
import {ifDefined} from 'lit/directives/if-defined.js';

export const BRAND_BUTTON_ELEMENT_TAG = 'fly-brand-button';

export enum BrandIcon {
  BASE = 'base',
  CREATE = 'create',
  INVITATION = 'invite',
  REQUEST = 'comment',
  CREATE_DATASET = 'create_dataset',
  DESCRIPTION = 'description',
}

export const brandIconURLMap: Map<BrandIcon, string> = new Map([
  [BrandIcon.BASE, ''],
  [BrandIcon.CREATE, `${ASSETS_PATH}/flywheel_audience_create.svg`],
  [BrandIcon.CREATE_DATASET, `${ASSETS_PATH}/add_dataset.svg`],
  [BrandIcon.REQUEST, `${ASSETS_PATH}/comment_icon.svg`],
  [BrandIcon.INVITATION, `${ASSETS_PATH}/invite_icon.svg`],
  [BrandIcon.DESCRIPTION, `${ASSETS_PATH}/description.svg`],
]);

const cssPropsMap = new Map([['width', '--fly-brand-button-w']]);

/**
 * BrandButton -- Description here
 */
@customElement(BRAND_BUTTON_ELEMENT_TAG)
export default class FlyBrandButton extends FlywheelComponent {
  @property()
  icon: BrandIcon = BrandIcon.BASE;

  @property({type: String})
  width = '100%';

  @property({type: String})
  alt?: string;

  @property({type: Boolean, reflect: true})
  disabled = false;

  static get styles() {
    return [styles];
  }

  private updateCSSProperty(property: string, value: string): void {
    if (cssPropsMap.has(property) && property in this) {
      this.style.setProperty(cssPropsMap.get(property)!, value);
    }
  }

  protected updated(changes: Map<PropertyKey, unknown>): void {
    if (changes.has('width')) {
      this.updateCSSProperty('width', this.width);
    }
  }

  render() {
    return html`
      <button
        class="brand-button brand-button__${this.className}"
        ?disabled=${this.disabled}
      >
        ${Boolean(this.icon) && Boolean(brandIconURLMap.get(this.icon))
          ? html`
              <div class="brand-button__icon">
                <img
                  alt=${ifDefined(this.alt)}
                  src="${ifDefined(brandIconURLMap.get(this.icon))}"
                />
              </div>
            `
          : nothing}
        <slot></slot>
      </button>
    `;
  }
}

FlywheelComponent.tagRegistry.add(BRAND_BUTTON_ELEMENT_TAG);

declare global {
  interface HTMLElementTagNameMap {
    [BRAND_BUTTON_ELEMENT_TAG]: FlyBrandButton;
  }
}
